import ErrorText from "@/components/ErrorText/ErrorText";
import styles from "./InputWithLabelAndError.module.scss";
import { combineClasses } from "@/lib/utils";
import { useFormState } from "react-hook-form";
import { useState } from "react";

const withLabelAndError = (InputComponent, popupText = "", PopupComponent) => {
  const InputWithLabelAndError = ({
    controlType,
    errorMessage,
    isRequired,
    ...props
  }) => {
    const { control, label, name } = props;
    const [showPopup, setShowPopup] = useState();
    //eslint-disable-next-line
    const { errors } = control ? useFormState({ control, name }) : {};

    const togglePopup = () => setShowPopup((prev) => !prev);

    const labelHtml = (
    <div className={styles.labelWrapper}>
      <label className={styles.label} htmlFor={name}>
    {label}
    {isRequired ? <span className={styles.requiredMark}>*</span> : ""}
  </label>
  
  {Boolean(popupText) && PopupComponent && (
  <span
    className={styles.popupText}
    onClick={(e) => {
      e.stopPropagation();
      e.preventDefault();
      togglePopup();
    }}
  >
    {popupText}
  </span>
)}

{PopupComponent && showPopup && <PopupComponent onClose={togglePopup} />}

  </div>
    );

    const errorHtml = (
      <ErrorText className={styles.error}>
        {errors?.[name]?.message || errorMessage || ""}
      </ErrorText>
    );

    return controlType === "checkbox" ? (
      <div
        className={combineClasses(styles.inputControl, styles.checkboxControl)}
      >
        <div className={styles.checkboxContainer}>
          <InputComponent {...props} />
          {labelHtml}
        </div>
        {errorHtml}
      </div>
    ) : (
      <div
        className={combineClasses(
          styles.inputControl,
          controlType === "textarea" && styles.textareaControl
        )}
      >
        {labelHtml}
        <InputComponent {...props} />
        {errorHtml}
      </div>
    );
  };

  return InputWithLabelAndError;
};

export default withLabelAndError;
